interface Props {
  width?: string
  height?: string
  rounded?: 'sm' | 'md' | 'lg' | 'full'
  className?: string
}

const roundedMap = {
  sm: 'var(--radius-sm)',
  md: 'var(--radius-md)',
  lg: 'var(--radius-lg)',
  full: '9999px',
}

export default function Skeleton({
  width = '100%',
  height = '16px',
  rounded = 'sm',
  className = '',
}: Props) {
  return (
    <div
      className={`animate-pulse ${className}`}
      style={{
        width,
        height,
        borderRadius: roundedMap[rounded],
        backgroundColor: 'var(--tg-theme-secondary-bg-color)',
      }}
    />
  )
}
